import React from "react";
import { Link } from "react-router-dom";
import AdminDashboard from "./admindashboard";
import "./hm-theme.css";

function Settings() {
  const role = JSON.parse(localStorage.getItem("data") || "{}").role;

  return (
    <div>
      <AdminDashboard />
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">settings</i>
                Settings
              </h2>
              <p className="hm-page-subtitle">Configure application settings and preferences</p>
            </div>
          </div>

          {/* Settings Options Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">tune</i>
                System Configuration
              </h3>
            </div>
            <div className="hm-card-body">
              <div className="hm-report-nav-grid">

                <Link
                  to="/users/financial-year-settings"
                  className="hm-report-nav-card"
                >
                  <div className="hm-report-nav-icon blue">
                    <i className="material-icons">date_range</i>
                  </div>
                  <div>
                    <p className="hm-report-nav-label">Fiscal Year Settings</p>
                    <p className="hm-report-nav-sub">Configure financial year periods</p>
                  </div>
                  <i className="material-icons ms-auto text-muted" style={{ fontSize: "1.1rem" }}>
                    chevron_right
                  </i>
                </Link>

                {role === "ROLE_SUPER" && (
                  <Link
                    to="/users/documentation"
                    className="hm-report-nav-card"
                  >
                    <div className="hm-report-nav-icon cyan">
                      <i className="material-icons">description</i>
                    </div>
                    <div>
                      <p className="hm-report-nav-label">Documentation</p>
                      <p className="hm-report-nav-sub">System guides & documentation</p>
                    </div>
                    <i className="material-icons ms-auto text-muted" style={{ fontSize: "1.1rem" }}>
                      chevron_right
                    </i>
                  </Link>
                )}

                <Link
                  to="/users/smtp-config"
                  className="hm-report-nav-card"
                >
                  <div className="hm-report-nav-icon blue">
                    <i className="material-icons">mark_email_read</i>
                  </div>
                  <div>
                    <p className="hm-report-nav-label">SMTP Configuration</p>
                    <p className="hm-report-nav-sub">Email server & credentials</p>
                  </div>
                  <i className="material-icons ms-auto text-muted" style={{ fontSize: "1.1rem" }}>
                    chevron_right
                  </i>
                </Link>

                {role === "ROLE_SUPER" && (
                  <Link
                    to="/users/email-statistics"
                    className="hm-report-nav-card"
                  >
                    <div className="hm-report-nav-icon cyan">
                      <i className="material-icons">insights</i>
                    </div>
                    <div>
                      <p className="hm-report-nav-label">Email Statistics</p>
                      <p className="hm-report-nav-sub">View email dispatch analytics</p>
                    </div>
                    <i className="material-icons ms-auto text-muted" style={{ fontSize: "1.1rem" }}>
                      chevron_right
                    </i>
                  </Link>
                )}

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Settings;
